// Lets non-React code (the verification thunks building credential headers in
// utils/verificationCredentials.ts) read the candidate JWT the AuthProvider
// holds, without importing the Redux store. Same pattern as
// authLogoutTrigger.ts. Redux used to carry this value in candidateLogin;
// after ECDEX-3441 (MR F) it only lives in the Context, and session storage
// is not enough on its own: the login paths skip the write when storage is
// unavailable.
let readJwt: (() => string | undefined) | null = null;

export const setCandidateJwtReader = (
  next: (() => string | undefined) | null,
) => {
  readJwt = next;
};

// Unregisters `next` only if it is still the registered reader, so an
// unmounting provider can't clobber one that registered after it.
export const clearCandidateJwtReader = (next: () => string | undefined) => {
  if (readJwt === next) readJwt = null;
};

// Empty until a provider has mounted, and after logout.
export const getCandidateJwt = (): string | undefined =>
  readJwt?.() || undefined;
